"use client";

import { ToastContainer } from "react-toastify";
import { useDarkMode } from "usehooks-ts";

export default function ToastContainerWrapper() {
  const { isDarkMode } = useDarkMode();
  return (
    <ToastContainer
      icon={false}
      position="top-right"
      theme={isDarkMode ? "dark" : "light"}
    />
  );
}
